import _objectSpread from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted } from "vue";
import DateRangeSelector from "@/components/ui/date-range/DateRangeSelector.vue";
import { useWeeklyDateRange } from "@/composables/useWeeklyDateRange.ts";
import { useI18n } from "vue-i18n";
import { getISOWeek } from "@/composables/useWeeklyDateRange.ts";
export default {
  __name: 'WeeklyDateRangeSelector',
  props: {
    initialSelectedWeek: {
      type: Object,
      required: false,
      default: null
    },
    selectedWeek: {
      type: Object,
      required: true
    },
    weekRangeLength: {
      type: Number,
      required: false,
      default: 4
    }
  },
  emits: ["update:selected-week"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      $tf = _useI18n.t;
    var props = __props;
    var emit = __emit;

    // Use the weekly date range composable
    var _useWeeklyDateRange = useWeeklyDateRange(props.weekRangeLength),
      currentWeek = _useWeeklyDateRange.currentWeek,
      isPreviousDisabled = _useWeeklyDateRange.isPreviousDisabled,
      isNextDisabled = _useWeeklyDateRange.isNextDisabled,
      getWeeklyRange = _useWeeklyDateRange.getWeeklyRange,
      prevWeek = _useWeeklyDateRange.previousWeek,
      nextWeekFn = _useWeeklyDateRange.nextWeek,
      resetWeek = _useWeeklyDateRange.resetToCurrentWeek;

    // Emit week update with the current week data
    var emitWeekUpdate = function emitWeekUpdate() {
      var weeklyRange = getWeeklyRange();
      emit("update:selected-week", _objectSpread({
        weekNumber: currentWeek.value
      }, weeklyRange));
    };

    // Wrapper functions to emit updates
    var previousWeek = function previousWeek() {
      prevWeek();
      emitWeekUpdate();
    };
    var nextWeek = function nextWeek() {
      nextWeekFn();
      emitWeekUpdate();
    };
    var resetToCurrentWeek = function resetToCurrentWeek() {
      resetWeek();
      emitWeekUpdate();
    };

    // Initialize with current week
    onMounted(function () {
      // Only set current week if no prop value is provided
      if (!props.initialSelectedWeek) {
        // Initialize with previous 2 weeks
        currentWeek.value = getISOWeek(new Date()) - 2;
        emitWeekUpdate();
      } else {
        currentWeek.value = props.initialSelectedWeek;
        emitWeekUpdate();
      }
    });
    onUnmounted(function () {
      resetToCurrentWeek();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(DateRangeSelector, {
        "display-label": _unref(getWeeklyRange)().label,
        "is-previous-disabled": _unref(isPreviousDisabled),
        "is-next-disabled": _unref(isNextDisabled),
        "previous-label": _unref($tf)('timeManagement.previousWeek.label'),
        "next-label": _unref($tf)('timeManagement.nextWeek.label'),
        "previous-tooltip": _unref($tf)('timeManagement.previousWeek.tooltip'),
        "next-tooltip": _unref($tf)('timeManagement.nextWeek.tooltip'),
        onPrevious: previousWeek,
        onNext: nextWeek,
        onReset: resetToCurrentWeek
      }, null, 8, ["display-label", "is-previous-disabled", "is-next-disabled", "previous-label", "next-label", "previous-tooltip", "next-tooltip"])]);
    };
  }
};